module.exports = __webpack_public_path__ + "img/brand_bg.c9bfbd25.jpg";